module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.isLoading),
      expression: "isLoading"
    }],
    staticClass: "main"
  }, [_c('plat-form-component', {
    attrs: {
      "option": {
        dateRadio: false
      }
    },
    on: {
      "updateData": _vm.updateData
    }
  }), _vm._v(" "), _c('transaction-component', {
    attrs: {
      "resultDataSum": _vm.resultDataSum,
      "salePlatform": _vm.salePlatform
    }
  }), _vm._v(" "), _c('trends-component', {
    attrs: {
      "resultDataDaily": _vm.resultDataDaily,
      "salePlatform": _vm.salePlatform
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8d471706","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/dataPlatform/menpiao/transactionData/Main.vue
// module id = 872
// module chunks = 0